import { cn } from "@ui/shadCN/lib/utils";

export function TagsRender({
  tags,
  srTitle,
  className,
}: {
  tags?: string[];
  srTitle?: string;
  className?: string;
}) {
  if (!tags || !tags.length) {
    return null;
  }

  return (
    <section aria-label={srTitle} title={srTitle}>
      <ul className={cn("flex flex-wrap gap-2", className)}>
        {tags.map((tag) => (
          <li key={`${srTitle}_${tag}`} className="rounded text-sm px-2 py-0.5">
            {tag}
          </li>
        ))}
      </ul>
    </section>
  );
}
